<template>
  <div>
    <p class="has-text-weight-bold is-size-4 mb-2">
      {{ $t("af:preliminary.first_step.title") }}
    </p>

    <p class="has-text-grey-icon">
      {{ $t("af:preliminary.first_step.subtitle") }}
    </p>

    <p class="label mt-5 mb-6">
      {{ $t("af:preliminary.first_step.amount.title") }}
    </p>

    <validation-observer ref="observer">
      <BInputWithValidation
        id="prelimAmountInput"
        :label="$t('af:preliminary.first_step.input.down_payment.label')"
        :mask="FIELD_MASK.HUF"
        :rules="{ required: true, regex: /^[0-9 ]*$/ }"
        label-position="on-border"
        :value="downPayment"
        :show-success="false"
        ref="downPaymentInput"
        @blur="adjustDownPayment"
      >
        <div class="loan-min-max has-text-grey-icon is-size-7">
          <span> Min. {{ filterSettings.downPaymentMin | monify }} HUF</span>
          <span> Max. {{ filterSettings.downPaymentMax | monify }} HUF</span>
        </div>
      </BInputWithValidation>
      <BInputWithValidation
        id="prelimAmountInput"
        style="display: block; margin-top: 1.5rem"
        :label="$t('af:preliminary.first_step.input.amount.label')"
        :mask="FIELD_MASK.HUF"
        :rules="{ required: true, regex: /^[0-9 ]*$/ }"
        label-position="on-border"
        :value="amount"
        :show-success="false"
        ref="amountInput"
        @blur="adjustAmount"
      >
        <div class="loan-min-max has-text-grey-icon is-size-7">
          <span> Min. {{ filterSettings.amountMin | monify }} HUF</span>
          <span> Max. {{ filterSettings.amountMax | monify }} HUF</span>
        </div>
      </BInputWithValidation>

      <LeasingTermSlider class="mt-5" v-model="duration" />
    </validation-observer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { FIELD_MASK } from "@/utils/const";

export default {
  name: "LeasingPrescoreAmountAndTerm",
  components: {
    BInputWithValidation: () => import("@/components/BInputWithValidation.vue"),
    LeasingTermSlider: () => import("@/components/LeasingTermSlider.vue"),
  },
  props: {},
  data() {
    return {
      amount: 0,
      duration: 0,
      downPayment: 0,
      FIELD_MASK,
    };
  },
  computed: {
    ...mapGetters({
      filterSettings: "leasing/filterSettings",
      publicId: "leasing/publicId",
      prescore: "leasingPrescore/getPrescore",
    }),
  },
  async created() {
    // this.downPayment =
    //   this.prescore.downPayment || this.filterSettings.downPaymentMin;
    // this.amount = this.prescore.amount || this.filterSettings.amountMin;
    // this.duration = this.prescore.duration || this.filterSettings.durationMin;
  },
  watch: {
    amount() {
      this.amountWatcher();
    },
    downPayment() {
      this.downPaymentWatcher();
    },
    duration() {
      this.durationWatcher();
    },
    filterSettings: {
      handler() {
        this.downPayment =
          this.prescore.downPayment || this.filterSettings.downPaymentMin;
        this.amount = this.prescore.amount || this.filterSettings.amountMin;
        this.duration =
          this.prescore.duration || this.filterSettings.durationMin;
      },
      // deep: true,
    },
  },
  methods: {
    ...mapActions({
      updatePrescore: "leasingPrescore/updatePrescore",
    }),
    getAmountFromStore(questionId) {
      return this.$store.getters["leasingPrescore/answer"](questionId);
    },
    storeData(questionId) {
      this.$store.dispatch("leasingPrescore/addData", {
        question: questionId,
        answer: this[questionId],
      });
    },
    amountWatcher() {
      this.storeData("amount");
      this.updatePrescore({ amount: this.amount });
    },
    downPaymentWatcher() {
      this.storeData("downPayment");
      this.updatePrescore({ downPayment: this.downPayment });
    },
    durationWatcher() {
      this.storeData("duration");
      this.updatePrescore({ duration: this.duration });
    },
    adjustAmount(amountInput) {
      amountInput = Number(amountInput);

      if (!isNaN(amountInput)) {
        let adjustedAmount = amountInput;

        if (amountInput % this.filterSettings.amountStep !== 0) {
          adjustedAmount =
            Math.round(amountInput / this.filterSettings.amountStep) *
            this.filterSettings.amountStep;
        }

        if (adjustedAmount < this.filterSettings.amountMin) {
          adjustedAmount = this.filterSettings.amountMin;
        } else if (adjustedAmount > this.filterSettings.amountMax) {
          adjustedAmount = this.filterSettings.amountMax;
        }

        this.amount = adjustedAmount;
        this.$refs.amountInput.forceUpdate(adjustedAmount);
      }
    },
    adjustDownPayment(amountInput) {
      amountInput = Number(amountInput);

      if (!isNaN(amountInput)) {
        let adjustedAmount = amountInput;

        // if (amountInput % this.filterSettings.amountStep !== 0) {
        //   adjustedAmount =
        //     Math.round(amountInput / this.filterSettings.amountStep) *
        //     this.filterSettings.amountStep;
        // }

        // if (adjustedAmount < this.filterSettings.amountMin) {
        //   adjustedAmount = this.filterSettings.amountMin;
        // } else if (adjustedAmount > this.filterSettings.amountMax) {
        //   adjustedAmount = this.filterSettings.amountMax;
        // }

        this.downPayment = adjustedAmount;
        this.$refs.downPaymentInput.forceUpdate(adjustedAmount);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.offer-change-info {
  display: flex;
  align-items: center;
}

.loan-min-max {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
</style>
